import { stat } from 'fs';
import { DeNghiMuaHangService } from './../../../mua-hang/de-nghi-mua-hang/de-nghi-mua-hang-service/de-nghi-mua-hang.service';
import { select } from '@ngrx/store';
import {
	Component,
	OnInit,
	ElementRef,
	ViewChildren,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Inject,
	HostListener,
	ViewRef
}
	from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject, BehaviorSubject } from 'rxjs';
//Service
import { YeuCauDuyetGiaService } from '../yeu-cau-duyet-gia-service/yeu-cau-duyet-gia.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';

import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType, QueryParamsModel } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { YeuCauDuyetGia, YeuCauDuyetGiaChiTiet } from '../yeu-cau-duyet-gia-model/yeu-cau-duyet-gia.model';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import moment from 'moment';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { TimKiemNangCaoListComponent } from '../tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { FlexAlignStyleBuilder } from '@angular/flex-layout';

@Component({
	selector: 'm-gui-lai-duyet-gia',
	templateUrl: './gui-lai-duyet-gia.component.html',
	styleUrls: ['../yeu-cau-duyet-gia.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class GuiLaiDuyetGiaComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;

	/* Các trường focus cho các tag trong form */
	@ViewChildren('focusMaKH') focusMaKH;
	@ViewChildren('focusGhiChu') focusGhiChu;
	@ViewChildren('focusThue') focusThue;
	@ViewChildren('focusGiaMoi') focusGiaMoi;
	@ViewChildren('focusSL') focusSL;
	@ViewChildren('focusDetail') focusDetail;
	@ViewChildren('focusLyDo') focusLyDo;

	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild('trigger', { static: true }) _trigger: MatMenuTrigger;

	/* Comment columns mat-table
		Các trường columns cho bảng:
		- displayedColumns: display ra form
		- availableColumns: các cột sẽ được add vào display.
		- extendsColumns: các cột mở rộng thêm cho display khi QC kiểm tra
	*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MAHH',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TENHH',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'QUYCACH',
			displayName: 'Quy cách',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'DONVITINH',
			displayName: 'Đon vị tính',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'SOLUONG',
			displayName: 'Số lượng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'NGAYYEUCAUGIAOHANG',
			displayName: 'Ngày yêu cầu giao hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'THOIGIANGIUGIA',
			displayName: 'Thời gian giữ giá',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'LOAITIEN',
			displayName: 'Loại tiền',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'GIAMOI',
			displayName: 'Giá mới',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'TONGSLTON',
			displayName: 'Tổng SL tồn',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'SOLO',
			displayName: 'Số lô',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'SLTON',
			displayName: 'SL Tồn',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'GIARECOMMAND',
			displayName: 'Giá recommand',
			alwaysChecked: false,
			isShow: true
		},

		{
			stt: 8,
			name: 'THANHTIEN',
			displayName: 'Thành tiền',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'THANHTIENQUYDOI',
			displayName: 'Thành tiền quy đổi',
			alwaysChecked: false,
			isShow: true
		},

		{
			stt: 9,
			name: 'TRANGTHAI',
			displayName: 'Trạng thái',
			alwaysChecked: false,
			isShow: true
		},
	];
	extendsColumn = [
		{
			stt: 99,
			name: 'ACTIONS',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		},
	];

	listidHH: any[] = [
		{
			value: '5',
			name: 'Bán thành phẩm'
		},
		{
			value: '4',
			name: 'Thành phẩm'
		}
	];

	/* End comment columns mat-table -------------------------------------*/

	/* Mat select search cho nhà cung cấp */
	listListNCC: any[] = [];
	selectListNCC: string = '';
	filteredListNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListNCCFilterCtrl: string = '';
	haveElementListNCC: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Mat select search cho khach hang */
	listListKH: any[] = [];
	selectListKH: string = '';
	filteredListKH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListKHFilterCtrl: string = '';
	haveElementListKH: boolean = false;
	/* ------------------------------------------------------------------ */
	/* Mat select search cho hàng hóa */
	listId_HH: any[] = [];
	selectId_HH: string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	/* ------------------------------------------------------------------ */
	/* Mat select search cho hop dong */
	listHD: any[] = [];
	selectHD: string = '';
	filteredHD: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	HDFilterCtrl: string = '';
	haveElementHD: boolean = false;

	listYCBG: any[] = [];
	selectYCBG: string = '';
	filteredYCBG: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	YCBGFilterCtrl: string = '';
	haveElementYCBG: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Giá trị đầu tiên cho dropdown quyết định nhập hàng - Form QC kiểm tra*/
	selectQuyetDinhLoHang = '0';
	/* ------------------------------------------------------------------ */

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<YeuCauDuyetGiaChiTiet>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	previousIndex: number; 			// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                 // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;		// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    // Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []	// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   // Loading khi mở dialog
	canEdit: boolean = false;		// Dialog có thể chỉnh sửa không?
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	MainForm: FormGroup;				//Form phiếu đề nghị
	ConfirmForm: FormGroup;			//Form add hàng hóa cho phiếu
	TitleTable: FormGroup;
	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	YeuCauDuyetGiaItem: YeuCauDuyetGia;

	/* Danh sách chi tiết hàng hóa của phiếu đề nghị:  */
	listChiTietHangVe: YeuCauDuyetGiaChiTiet[] = [];

	/* Danh sách tạm chi tiết hàng hóa của phiếu đề nghị dùng để cập nhập trên lưới  */
	tmpChiTietYeuCauDuyetGia: YeuCauDuyetGiaChiTiet[] = [];

	/* Danh sách chi tiết hàng hóa của phiếu đề nghị lúc đầu dùng để so sánh -> cập nhập trạng thái phiếu */
	compareChiTietHangVe: YeuCauDuyetGiaChiTiet[] = [];

	/* Danh sách tình trạng phiếu */




	/* hàng hóa */
	list_HH: any[] = [];
	select_HH: string = '';
	filtered_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	HH_FilterCtrl: string = '';
	haveElement_HH: boolean = false;
	/* ------------------------------------------------------------------ */


	/* tên sản phẩm */
	list_SP: any[] = [];
	select_SP: string = '';
	filtered_SP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	SP_FilterCtrl: string = '';
	haveElement_SP: boolean = false;
	/* ------------------------------------------------------------------ */

	/* phiếu yêu cầu báo giá */
	list_YCBG: any[] = [];
	select_YCBG: string = '';
	filtered_YCBG: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	YCBG_FilterCtrl: string = '';
	haveElement_YCBG: boolean = false;
	/* ------------------------------------------------------------------ */



	TinhTrang = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'KDYCDG_DANGSOANTHAO',
		},
		{
			id: 2,
			name: 'Chờ duyệt',
			value: 'KDYCDG_CHODUYET',
		},
		{
			id: 3,
			name: 'Không duyệt',
			value: 'KDYCDG_KHONGDUYET',
		},
		{
			id: 4,
			name: 'Hoàn tất',
			value: 'KDYCDG_HOANTAT',
		},
		{
			id: 5,
			name: 'Đã hủy',
			value: 'KDYCDG_DAHUY',
		},
		{
			id: 6,
			name: 'Đã xóa',
			value: 'KDYCDG_DAXOA',
		},
		,
		{
			id: 7,
			name: 'Đang thực hiện',
			value: 'KDYCDG_DANGTHUCHIEN',
		}
	];

	show_area_1: boolean = false;
	add: boolean = false;
	edit: boolean = false;
	confirm: boolean = false;
	detail: boolean = false;
	guilai: boolean = false;

	arrIdHangHoa = [];
	currency_unit = [];
	danh_sach_lot = [];
	keywordSoLo = '';
	tiente_id_default = 0;
	tiente_name_default = '';

	listTonKhoHienTai: any[] = [];

	minDate = moment(new Date()).format('YYYY-MM-DD');

	openFormKH: boolean = false;
	shownut: boolean = false;
	payments = [];
	GiaCu: number;
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.keyCode == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode) {
			this.back();
		}
		if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE.KeyCombine.keycode && (this.add || this.edit)) {
			this.setYeuCauDuyetGia(1);
		}
		if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_NEW.KeyCombine.keycode && (this.add || this.edit)) {
			this.setYeuCauDuyetGia(2);
		}
		if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_TMP.KeyCombine.keycode && (this.add || this.edit)) {
			this.setYeuCauDuyetGia(0);
		}
		if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.NOT_CONFIRM.KeyCombine.keycode && this.confirm) {
			this.setConfirmForm(false);
		}
		if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.CONFIRM.KeyCombine.keycode && this.confirm) {
			this.setConfirmForm(true);
		}
	}
	_idsp: number = 0;
	_idYCBG: number = 0;
	_idHH: string = ''
	constructor(
		public dialogRef: MatDialogRef<GuiLaiDuyetGiaComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private YeuCauDuyetGiaService: YeuCauDuyetGiaService,
		private DungChungService: DungChungService,
		public dialog: MatDialog,
		private MainFormFB: FormBuilder,
		private ConfirmFormFB: FormBuilder,
		private TitleTableFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef,
		private deNghiMuaHangService: DeNghiMuaHangService
	) { }

	/** LOAD DATA */
	async ngOnInit() {
		this.CONFIG = new CommonConFig();
		this.show_area_1 = this.data.show_area_1 ? this.data.show_area_1 : false;
		this.add = this.data.add ? this.data.add : false;
		this.edit = this.data.edit ? this.data.edit : false;
		this.detail = this.data.detail ? this.data.detail : false;
		this.confirm = this.data.confirm ? this.data.confirm : false;
		this.guilai = this.data.guilai ? this.data.guilai : false;
		this.YeuCauDuyetGiaItem = new YeuCauDuyetGia;
		this.YeuCauDuyetGiaItem.clear();
		this.getPayments();
		this.getListHHMultiple();
		this.createForm();

		let __idDG = this.data.data.IdDG;
		if (this.add || this.edit) {
			this.shownut = true;
		}
		if (this.add) {
			var tenNguoiLap = '';
			this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
			this.MainForm.controls['NGUOILAPPHIEU'].setValue(tenNguoiLap);
			this.createBillNumber().then(r => { this.MainForm.controls['SOPHIEU'].setValue(r); });
			this.MainForm.controls['TRANGTHAI'].setValue(this.TinhTrang[0].name);
			this.changeDetect.detectChanges()

		}
		else if (this.edit || this.confirm || this.guilai) {
			this.YeuCauDuyetGiaService.liteId(__idDG, this.data.data.IdDGCT).subscribe(res => {
				if (res && res.status === 1) {
					this.YeuCauDuyetGiaItem = res.data[0];
					this.createForm();
					if (this.guilai) {

						let controls = this.MainForm.controls;
						this.GiaCu = this.formatComparenumber(controls['GIAMOI'].value.toString());

						this.createBillNumber().then(r => { controls['SOPHIEU'].setValue(r); });
						var tenNguoiLap = '';
						this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
						controls['NGUOILAPPHIEU'].setValue(tenNguoiLap);
						controls['TRANGTHAI'].setValue(this.TinhTrang[0].name);
					}
					this.changeDetectView();
				}
			});
		}
		else {
			this.YeuCauDuyetGiaService.detail(__idDG).subscribe(res => {
				if (res && res.status === 1) {
					this.YeuCauDuyetGiaItem = res.data[0];
					this.createForm();
					this.changeDetectView();
				}
			});
		}




		// if(this.edit || this.confirm){
		// 	this.YeuCauDuyetGiaService.liteId(__idDG).subscribe(res =>{
		// 		if(res && res.status === 1){
		// 			this.YeuCauDuyetGiaItem = res.data[0];
		// 			this.createForm();
		// 			this.changeDetect.detectChanges()
		// 		}
		// 	});
		// 	if(this.confirm){
		// 		this.MainForm.controls['YCBGCT'].disable();
		// 	}
		// }
		// if(this.guilai){
		// 	this.YeuCauDuyetGiaService.liteId(__idDG).subscribe(res =>{
		// 		if(res && res.status === 1){
		// 			this.YeuCauDuyetGiaItem = res.data[0];
		// 			this.createForm();


		// 		}
		// 	});

		// }
		// if(this.add || this.edit){
		// 	this.extendsColumn.forEach(element => {
		// 		this.availableColumns.splice(this.availableColumns.length-1, 0 ,element);
		// 	});
		// 	this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		// }

		/*Show column */
		// this.showColumnsInTable();
		// this.applySelectedColumns();
		this.changeDetect.detectChanges()
	}

	async getPayments() {
		let res = await this.DungChungService.getDSTienTe().toPromise();
		if (res && res.status === 1) {
			this.payments = res.data;
			if (this.payments.length > 0) this.MainForm.controls['LOAITIEN'].setValue(this.payments[0].Id.toString());
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
		this.changeDetectView();
	}

	ngAfterViewInit() {
		/*Focus on first input field*/
		//this.changeDetect.detectChanges();
		this.changeDetectView();
	}

	//#region checkPositiveNumbers
	kiemTraGiaTriMin(event, min: number = 0) {
		FunctionPublic.kiemTraGiaTriMin(event, min);
	}
	//#endregion checkPositiveNumbers

	/*Create Form with appropriate sub forms */
	createForm() {
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		var item = this.YeuCauDuyetGiaItem;
		this.MainForm = this.MainFormFB.group({
			SOPHIEU: [item.SoPhieu, Validators.required],
			NGAYLAPPHIEU: [item.NgayLapPhieu ? item.NgayLapPhieu : new Date(), Validators.required],
			NGAYYEUCAUBAOGIA: [item.NgayYCBG ? item.NgayYCBG : new Date(), Validators.required],
			NGUOILAPPHIEU: [item.TenNguoiLapPhieu, Validators.required],
			TRANGTHAI: [item.TrangThai_Desc, Validators.required],
			SOPHIEUYCBG: [item.IdYCBG + '', Validators.required],
			IdHH: [item.IdHH, Validators.required],
			YCBGCT: [item.YCBGCT == 0 ? '' : item.YCBGCT + '', Validators.required],
			MaHH: [item.MaHH, Validators.required],
			MaKH: [item.MaKH],
			TenKH: [item.TenKH],
			GHICHU: [item.GhiChu],
			TenHH: [item.TenHH],
			QUYCACH: [item.QuyCachDongGoi],
			DVT: [item.TenDVT],
			SOLUONG: [this.f_currency_VND(this.formatNumber(item.SoLuong.toString())), Validators.required],
			SOLUONGTON: [this.f_currency_VND(this.formatNumber(item.TotalSoluongton.toString())), Validators.required],
			//RECOMMAND: [this.f_currency_VND(this.formatNumber('0'.toString())), Validators.required],
			MIN: [this.f_currency_VND(this.formatNumber(item.GiaMin.toString())), Validators.required],
			MAX: [this.f_currency_VND(this.formatNumber(item.GiaMax.toString())), Validators.required],
			GIAGANNHAT: [this.f_currency_VND(this.formatNumber(item.GiaGanNhat.toString())), Validators.required],
			GIAKHACHHANGMONGMUON: [this.f_currency_VND(this.formatNumber(item.GiaKhachHangMongMuon.toString())), Validators.required],
			GIAMOI: [this.f_currency_VND(this.formatNumber(item.GiaDeNghiBan.toString())), Validators.required],
			THOIHANGIUGIA: [item.ThoiGianGiuGia, Validators.required],
			NGAYYEUCAUGIAOHANG: [item.NgayYeuCauGiaoHang, Validators.required],
			KETLUAN: ['0'.toString(), Validators.required],
			LOAITIEN: [this.payments.length > 0 ? item.TienTeId.toString() : '', Validators.required],
			TYGIA: [this.f_currency_VND(this.formatNumber(item.TyGia.toString())), Validators.required],
			THANHTIEN: [this.f_currency_VND(this.formatNumber(item.ThanhTien.toString())), Validators.required],
			THANHTIENQUYDOI: [this.f_currency_VND(this.formatNumber(item.ThanhTienQuyDoi.toString())), Validators.required],
		});

		this.TitleTable = this.TitleTableFB.group({
			DONVI: ['', Validators.required],
			TYGIA: ['1', Validators.required],
		});

		this.MainForm.controls['SOPHIEU'].disable();
		this.MainForm.controls['NGUOILAPPHIEU'].disable();
		this.MainForm.controls['NGAYLAPPHIEU'].disable();
		this.MainForm.controls['TRANGTHAI'].disable();
		this.MainForm.controls['MaKH'].disable();
		this.MainForm.controls['TenKH'].disable();
		this.MainForm.controls['NGAYYEUCAUBAOGIA'].disable();
		this.MainForm.controls['MaHH'].disable();
		this.MainForm.controls['TenHH'].disable();
		this.MainForm.controls['SOLUONG'].disable();
		this.MainForm.controls['IdHH'].disable();
		this.MainForm.controls['DVT'].disable();
		this.MainForm.controls['QUYCACH'].disable();
		this.MainForm.controls['GIAGANNHAT'].disable();
		this.MainForm.controls['GIAKHACHHANGMONGMUON'].disable();
		this.MainForm.controls['GHICHU'].disable();
		this.MainForm.controls['MIN'].disable();
		this.MainForm.controls['MAX'].disable();
		this.MainForm.controls['SOLUONGTON'].disable();
		this.MainForm.controls['THANHTIEN'].disable();
		this.MainForm.controls['THANHTIENQUYDOI'].disable();
		//this.MainForm.controls['RECOMMAND'].disable();
		//this.MainForm.controls['KETLUAN'].disable();
		if (this.detail || this.confirm) {
			this.ConfirmForm = this.ConfirmFormFB.group({
				NGAYDUYET: [item.NgayDuyet ? item.NgayDuyet : this.confirm ? new Date() : ''],
				NGUOIDUYET: [item.TenNguoiDuyet ? item.TenNguoiDuyet : this.confirm ? tenNguoiLap : ''],
				LYDO: [item.LyDo]
			});
			this.MainForm.controls['GIAMOI'].disable();
			this.MainForm.controls['THOIHANGIUGIA'].disable();
			this.MainForm.controls['NGAYYEUCAUGIAOHANG'].disable();
			this.MainForm.controls['LOAITIEN'].disable();
			this.MainForm.controls['TYGIA'].disable();
			//this.MainForm.controls['SOPHIEUYCBG'].disable();
			this.MainForm.controls['YCBGCT'].disable();
			this.ConfirmForm.controls['NGAYDUYET'].disable();
			this.ConfirmForm.controls['NGUOIDUYET'].disable();

			if (this.detail) {
				this.ConfirmForm.controls['LYDO'].disable();
			}

		}
		if (this.guilai) {
			this.MainForm.controls['YCBGCT'].disable();
		}

	}

	/*Lấy tiêu đề cho dialog với các TH thêm - sửa - QC kiểm tra*/
	getTitle(): string {
		if (this.add) return 'THÊM MỚI YÊU CẦU DUYỆT GIÁ';
		if (this.edit) return 'CHỈNH SỬA YÊU CẦU DUYỆT GIÁ';
		if (this.confirm) return 'DUYỆT YÊU CẦU DUYỆT GIÁ';
		if (this.detail) return 'CHI TIẾT YÊU CẦU DUYỆT GIÁ';
		if (this.guilai) return 'GỬI LẠI YÊU CẦU DUYỆT GIÁ';
	}

	getSoPhieu() {
		return this.YeuCauDuyetGiaItem.SoPhieu;
	}

	/*Xóa dữ liệu hàng hóa trong bảng*/
	deleteItem(item: any) {
		let index = this.tmpChiTietYeuCauDuyetGia.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietYeuCauDuyetGia.splice(index, 1);
		}
		this.tmpChiTietYeuCauDuyetGia = [...this.tmpChiTietYeuCauDuyetGia];

		setTimeout(() => {
			this.focusDetail.first.open();
		}, 0);
	}

	/*Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	/*---------------------------------------------------------------------------------------- */
	/*Các hàm hỗ trợ cho mat select search Nhà cung cấp*/
	ListNCC() {
		this.DungChungService.listNCC().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listListNCC = res.data;
				this.filteredListNCC.next(this.listListNCC.slice());
				this.changeDetectView();
			};
		});
	}
	filterListNCC() {
		if (!this.listListNCC) {
			return;
		}
		// get the search keyword
		let search = this.ListNCCFilterCtrl;
		if (!search) {
			this.filteredListNCC.next(this.listListNCC.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListNCC.next(
			this.listListNCC.filter(ts =>
				ts.TenNCC.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	// ListKH(select: boolean = false, data: ThemMoiKhachHang = new ThemMoiKhachHang()){
	// 	setTimeout(() => {
	// 		this.focusMaKH.first.close();
	// 	}, 0);
	// 	this.DungChungService.listKH().subscribe(res => {
	// 		this.loadingSubject.next(false);
	// 		if (res && res.status === 1) {
	// 			this.listListKH = res.data;
	// 			this.filteredListKH.next(this.listListKH.slice());
	// 			if(select){
	// 				this.MainForm.controls['MAKH'].setValue(''+data.IdKh);
	// 				this.selectedMaKH();
	// 			}
	// 			this.changeDetect.detectChanges();

	// 		};
	// 	});
	// }
	// filterListKH() {
	// 	if (!this.listListKH) {
	// 		return;
	// 	}
	// 	// get the search keyword
	// 	let search = this.ListKHFilterCtrl;
	// 	if (!search) {
	// 		this.filteredListKH.next(this.listListKH.slice());
	// 		return;
	// 	} else {
	// 		search = search.toLowerCase();
	// 	}
	// 	this.filteredListKH.next(
	// 		this.listListKH.filter(ts =>
	// 			ts.MaKH.toLowerCase().indexOf(search) > -1)
	// 	);
	// 	this.changeDetect.detectChanges();
	// }
	/*------------------------------------------ */

	/*Hàm hỗ trợ format các dạng số trên form*/
	formatNumber(item: string) {
		if (!item) return '0.00';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint);
	}


	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0,00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}

	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
	}
	/*------------------------------------------------------------- */

	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return '0,00';
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}

	/*Hàm hỗ trợ format các dạng ngày trên form*/
	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/*------------------------------------------------------------- */

	//#region Tạo số phiếu tự động
	async createBillNumber() {
		var category_path = "YCDG";
		var res = await this.DungChungService.getBillNumber(category_path).toPromise().then(r => { return r });
		if (res && res.status == 1) {
			return res.data;
		}
		else {

			this.layoutUtilsService.showErorr("Không thể lấy số phiếu tự động.");
		}
	}
	//#endregion Tạo số phiếu tự động
	/* Kiểm tra gửi duyệt */
	checkGuiDuyet(checked: boolean = false) {
		if (checked) {
			this.MainForm.controls['TRANGTHAI'].setValue(this.TinhTrang[1].name);
		} else {
			this.MainForm.controls['TRANGTHAI'].setValue(this.TinhTrang[0].name);
		}
	}


	/* Mở danh sách phiếu đề nghị */
	back() {
		this.dialogRef.close({
			isChange: this.isChange,
			dataAdd: this.saveAddedTTHV
		});
	}

	validateInvalidForm(isAddDetail: boolean = false) {
		const controls = this.MainForm.controls;
		if (this.MainForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {
					if (invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT') {
						const elementControl = this.MainForm.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if (elementControl) {
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return false;
		}

		if (!isAddDetail) {
			setTimeout(() => this.focusDetail.first.nativeElement.focus(), 100);
		}
		return true;
	}
	closeDropdownEvent(dropdownName: string) {

		if (dropdownName == 'MaKH') {
			setTimeout(() => this.focusMaKH.first.close(), 0);
			this.changeDetectView();
		}
		this.validateInvalidForm();
		this.changeDetectView();
	}

	forcusAnotherEmptyField(control: any) {
		Object.keys(control).forEach(controlName => {

			if (control[controlName].value == null || control[controlName].value == undefined
				|| control[controlName].value == '') {


				if (controlName == 'GHICHU') {
					setTimeout(() => this.focusGhiChu.first.nativeElement.focus(), 0);
				}
			}

			this.changeDetectView();
		});
	}

	/*Các hàm hỗ trợ cho mat select search Hàng hóa*/
	async ListTonKho() {
		let res = await this.DungChungService.listTonKho().toPromise();
		if (res && res.status === 1) {
			this.listTonKhoHienTai = res.data;
			this.tmpChiTietYeuCauDuyetGia.forEach(item => {
				item.ListSoLo = this.getListSoLoTheoHH(item.IdHH);
			})
			this.changeDetectView();
		} else {

			this.layoutUtilsService.showErorr(res.error.message);
		}
	}

	getSLTonTheoSoLo(idhang: number, idlo: number) {

		let sum = 0;
		this.listTonKhoHienTai.forEach(x => {
			if (x.Id_Lo == idlo && x.Id_HH == idhang) {
				sum += x.So_Luong;
			}
		})
		return sum;
	}

	getSLTonTong(idhang: number) {
		let sum = 0;
		this.listTonKhoHienTai.forEach(x => {
			if (x.Id_HH == idhang) {
				sum += x.So_Luong;
			}
		})
		return sum;
	}

	getListSoLoTheoHH(idhang: number) {
		let arr = [];
		this.listTonKhoHienTai.forEach(x => {
			if (x.Id_HH == idhang && arr.findIndex(a => a.IdLot == x.Id_Lo) == -1) {
				let i = this.danh_sach_lot.findIndex(b => b.Id_Lot == x.Id_Lo);
				if (i > -1) arr.push({ Id_Lot: this.danh_sach_lot[i].Id_Lot, Ten_Lot: this.danh_sach_lot[i].Ten_Lot });
			}
		})
		return arr;
	}

	searchListLotHH(item: YeuCauDuyetGiaChiTiet) {
		// get the search keyword
		let search = this.keywordSoLo;
		if (!search) {
			item.ListSoLo = this.getListSoLoTheoHH(item.IdHH);
			return;
		}
		else {
			search = search.toLowerCase();
		}
		item.ListSoLo = this.getListSoLoTheoHH(item.IdHH).filter(ts => ts.Ten_Lot.toLowerCase().indexOf(search) > -1);
		this.changeDetectView();
	}

	updateItemLot(item: YeuCauDuyetGiaChiTiet, IdLot: any) {
		item.IdLo = +IdLot;
		item.SLTon = this.getSLTonTheoSoLo(item.IdHH, item.IdLo);
		let tmp = this.tmpChiTietYeuCauDuyetGia;
		this.tmpChiTietYeuCauDuyetGia = [];
		this.tmpChiTietYeuCauDuyetGia = [...tmp];
		this.changeDetectView();
	}

	//  getListYeuCauBaoGia(){
	// 	this.DungChungService.layDanhSachYeuCauBaoGia().subscribe(res=>{
	// 		if(res && res.status === 1){
	// 			this.list_YCBG = res.data;
	// 			this.filtered_YCBG.next(this.list_YCBG.slice());
	// 			if(this._idsp>0){
	// 				this.getListSanPhamTheoPhieuBaoGia();
	// 				this.getKHTheoPhieuBG();
	// 			}
	// 			this.changeDetectView();

	// 		}else{
	// 			this.layoutUtilsService.showErorr(res.error.message);
	// 			this.changeDetectView();
	// 		}
	// 	});


	// }

	async getListSanPhamTheoPhieuBaoGia() {
		var controls = this.MainForm.controls;
		let res = await this.DungChungService.layDanhSachSanPhamTheoPhieuBaoGia(controls['SOPHIEUYCBG'].value).toPromise();
		if (res && res.status === 1) {
			this.list_SP = res.data;
			this.filtered_SP.next(this.list_SP.slice());
			if (this._idsp > 0) {
				// this.changeSanPham();
			}
			this.changeDetectView();

		} else {
			this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetectView();
		}

	}

	async getListHHMultiple() {
		let res = await this.YeuCauDuyetGiaService.DanhSachHangHoa().toPromise();
		if (res && res.status === 1) {
			this.list_HH = res.data;
			this.filtered_HH.next(this.list_HH.slice());
			if (this._idsp > 0) {
				this.changeHH();
			}
			this.changeDetectView();

		} else {
			this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetectView();
		}

	}

	// filterYeuCauBaoGia() {
	// 	
	// 	if (!this.list_YCBG) {
	// 		return;
	// 	}
	// 	// get the search keyword
	// 	let search = this.YCBG_FilterCtrl;
	// 	if (!search) {
	// 		this.filtered_YCBG.next(this.list_YCBG.slice());
	// 		return;
	// 	} else {
	// 		search = search.toLowerCase();
	// 	}
	// 	this.filtered_YCBG.next(
	// 		this.list_YCBG.filter(ts =>
	// 			ts.SoPhieu.toLowerCase().indexOf(search) > -1)
	// 	);
	// 	this.changeDetectView();
	// }

	filterSanPham() {
		if (!this.list_SP) {
			return;
		}
		// get the search keyword
		let search = this.SP_FilterCtrl;
		if (!search) {
			this.filtered_SP.next(this.list_SP.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_SP.next(
			this.list_SP.filter(ts =>
				ts.TenSanPham.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	filterHH() {

		if (!this.list_HH) {
			return;
		}
		// get the search keyword
		let search = this.HH_FilterCtrl;
		if (!search) {
			this.filtered_HH.next(this.list_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_HH.next(
			this.list_HH.filter(ts =>
				ts.MaHH.toLowerCase().indexOf(search) > -1 || ts.SoPhieu.toLowerCase().indexOf(search) > -1 || ts.TenHH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	changeHH() {
		console.log(2);
		if (this.list_HH.length > 0) {
			var controls = this.MainForm.controls;
			var itemHH = this.list_HH.filter(x => x.Id_CT == controls['YCBGCT'].value);
			controls['IdHH'].setValue(itemHH[0].Id_HH);
			controls['MaHH'].setValue(itemHH[0].MaHH);
			controls['QUYCACH'].setValue(itemHH[0].QuyCachDongGoi);
			controls['TenHH'].setValue(itemHH[0].TenHH);
			controls['GHICHU'].setValue(itemHH[0].GhiChu);
			controls['MaKH'].setValue(itemHH[0].MaKH);
			controls['TenKH'].setValue(itemHH[0].TenKH);
			controls['DVT'].setValue(itemHH[0].TenDVT1);
			controls['NGAYYEUCAUBAOGIA'].setValue(itemHH[0].NgayYeuCauBG);
			controls['SOLUONGTON'].setValue(this.f_currency_VND(this.formatNumber(itemHH[0].TotalSoluongton)));
			controls['SOLUONG'].setValue(this.f_currency_VND(this.formatNumber(itemHH[0].SoLuong)));
			controls['MIN'].setValue(this.f_currency_VND(this.formatNumber(itemHH[0].GiaMin)));
			controls['MAX'].setValue(this.f_currency_VND(this.formatNumber(itemHH[0].GiaMax)));
			controls['GIAGANNHAT'].setValue(this.f_currency_VND(this.formatNumber(itemHH[0].GiaGanNhat)));
			controls['GIAKHACHHANGMONGMUON'].setValue(this.f_currency_VND(this.formatNumber(itemHH[0].GiaKhachHangMongMuon)));
			//controls['RECOMMAND'].setValue(this.f_currency_VND(this.formatNumber(itemHH[0].DonGiaRecommend)));
			this.changeDetect.detectChanges();
		}



	}

	// changeSanPham() {
	// 	if(this.list_SP.length>0){
	// 		var controls=this.MainForm.controls;
	// 	
	// 	var itemSP=this.list_SP.filter(x=>x.Id==controls['YCBGCT'].value);
	// 	controls['SOLUONG'].setValue(this.f_currency_VND(this.formatNumber(itemSP[0].SoLuong+'')));

	// 	this.changeDetectView();
	// 	}

	// }
	changePhieuBG() {

		if (!this.list_HH) {
			return;
		}
		// get the search keyword
		let search = this.HH_FilterCtrl;
		if (!search) {
			this.filtered_HH.next(this.list_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_HH.next(
			this.list_HH.filter(ts =>
				ts.MaHH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	async getListLot() {
		let res = await this.DungChungService.listLot().toPromise();
		if (res && res.status === 1) {
			this.danh_sach_lot = res.data;
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
		this.changeDetectView();
	}

	// async ListId_HH(){
	// 	let res = await this.deNghiMuaHangService.listHangHoa().toPromise();
	// 	if (res && res.status === 1) {
	// 		this.listId_HH = res.data;
	// 		this.filteredId_HH.next(this.listId_HH.slice());
	// 		if(this.add){
	// 			this.arrIdHangHoa.forEach(x =>{
	// 				let item = new YeuCauDuyetGiaChiTiet();
	// 				let i = this.listId_HH.findIndex(a => a.Id_HH == +x.IdHH);
	// 				if(i > -1){
	// 					item.IdHH = this.listId_HH[i].Id_HH;
	// 					item.MaHH = this.listId_HH[i].MaHH;
	// 					item.TenHH = this.listId_HH[i].TenHH;
	// 					item.QuyCach = this.listId_HH[i].QuyCach;
	// 					item.DVT = this.listId_HH[i].DVT;
	// 					item.TenDVT = this.listId_HH[i].TenDVT;
	// 					item.KhoiLuong = x.SLDeNghi;
	// 					item.NgayYeuCauGH = moment(new Date).format("YYYY-MM-DD hh:mm:ss").toString();
	// 					item.ThoiHanGiuGia = 1;
	// 					item.TienTe_Id = this.tiente_id_default;
	// 					item.TienTe_Ten = this.tiente_name_default;
	// 					item.GiaMoi = 0;
	// 					item.TongSLTon = this.getSLTonTong(item.IdHH);
	// 					item.ListSoLo = this.getListSoLoTheoHH(item.IdHH);
	// 					item.IdLo = 0;
	// 					item.SoLo = '';
	// 					item.SLTon = 0;
	// 					item.GiaRecommend = 0;
	// 					item.ThanhTien = 0;
	// 					item.ThanhTienQuyDoi = 0;
	// 					item.YCBGCT = x.IdCt;
	// 					item.TyGia = 1;
	// 					this.tmpChiTietYeuCauDuyetGia.push(item);
	// 				}
	// 			});
	// 			this.tmpChiTietYeuCauDuyetGia = [...this.tmpChiTietYeuCauDuyetGia];
	// 			this.changeDetectView();
	// 		}
	// 	}else{

	// 		this.layoutUtilsService.showErorr(res.error.message);
	// 	}
	// }
	filterId_HH(searchTmp: string = '') {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if (searchTmp != '')
			search = '' + searchTmp;

		if (!search) {
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if (searchTmp != '') {
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					(ts.MaHH + " - " + ts.TenHH).toLowerCase().indexOf(search) > -1)
			);
		}
		else {
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.MaHH.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}
	/*------------------------------------------ */

	deleteHang(item: any) {
		const index = this.tmpChiTietYeuCauDuyetGia.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietYeuCauDuyetGia.splice(index, 1);
		}
		let tmp = this.tmpChiTietYeuCauDuyetGia;
		this.tmpChiTietYeuCauDuyetGia = [];
		this.tmpChiTietYeuCauDuyetGia = [...tmp];

		setTimeout(() => {
			this.focusDetail.first.nativeElement.focus();
		}, 0);

		this.changeDetectView();
	}

	dateToDDMMYYYY(__data: any) {
		let __date = new Date(__data);
		return ("0" + __date.getDate()).slice(-2) + "/" + ("0" + (__date.getMonth() + 1)).slice(-2) + "/" + __date.getFullYear();
	}


	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");
	}

	//#region Cập nhat thành tiền quy đổi
	updateThanhTienQuyDoi() {
		let tygia = +(this.TitleTable.controls['TYGIA'].value.replace(/,/g, ""));
		if (!tygia) {
			tygia = 1;
			this.TitleTable.controls['TYGIA'].setValue('1');
		}
		this.tmpChiTietYeuCauDuyetGia.forEach(x => {
			x.ThanhTienQuyDoi = x.KhoiLuong * x.GiaMoi * tygia;
			x.TyGia = tygia;
		});

		let temp = this.tmpChiTietYeuCauDuyetGia;
		this.tmpChiTietYeuCauDuyetGia = [];
		this.tmpChiTietYeuCauDuyetGia = [...temp];
		this.changeDetectView();

	}
	//#endregion Cập nhat thành tiền quy đổi

	//#region Cap nhat ty gai dang tien te
	changeInputCurrency(event, columnName, formGroup) {
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				formGroup.controls[columnName].setValue(data);
				this.updateThanhTienQuyDoi();
				this.changeDetectView();
			}
		}
	}
	//#endregion 
	//#region Kiểm tra định dạng số lượng 
	keyUpInputNumber(event) {
		if (event.keyCode === 8 && event.target.value == '0') {
			event.preventDefault();
			return;
		};
		FunctionPublic.checkPositiveNumbers(event);
	}
	//#endregion Kiểm tra định dạng số lượng

	changeInputDonGia(event, index, item) {
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {

			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				this.tmpChiTietYeuCauDuyetGia[index].GiaMoi = data.replace(/,/g, "");
			} else {
				this.tmpChiTietYeuCauDuyetGia[index].GiaMoi = 0;
			}
			let tmp = this.tmpChiTietYeuCauDuyetGia[index];
			tmp.ThanhTien = item.KhoiLuong * tmp.GiaMoi;
			tmp.ThanhTienQuyDoi = tmp.ThanhTien * +this.formatNumber(this.TitleTable.controls['TYGIA'].value.replace(/,/g, ""));
			let temp = this.tmpChiTietYeuCauDuyetGia;
			this.tmpChiTietYeuCauDuyetGia = [];
			this.tmpChiTietYeuCauDuyetGia = [...temp];
			this.changeDetectView();
		}
	}

	changeValueOfList(controlName: string, event: any, index: number, item: YeuCauDuyetGiaChiTiet) {

		let tmpValue = event.target.value.replace(/,/g, "");
		if (!tmpValue || tmpValue == '') tmpValue = 0;
		let tmp = this.tmpChiTietYeuCauDuyetGia[index];
		tmp.GiaMoi = +this.formatNumber(tmpValue);
		tmp.ThanhTien = item.KhoiLuong * tmp.GiaMoi;
		tmp.ThanhTienQuyDoi = tmp.ThanhTien * +this.formatNumber(this.TitleTable.controls['TYGIA'].value.replace(/,/g, ""));
		let temp = this.tmpChiTietYeuCauDuyetGia;
		this.tmpChiTietYeuCauDuyetGia = [];
		this.tmpChiTietYeuCauDuyetGia = [...temp];
		this.changeDetectView();
	}

	changePayments(event) {
		let tiente_id = +event.value;
		let index = this.currency_unit.findIndex(a => a.Id === tiente_id);
		let tiente_ten = '';
		if (index > -1) tiente_ten = this.currency_unit[index].Ten;

		if (tiente_id > 0 && tiente_ten) {
			this.tmpChiTietYeuCauDuyetGia.forEach(x => {
				x.TienTe_Id = tiente_id;
				x.TienTe_Ten = tiente_ten;
			})
			this.changeDetectView();
		}
	}
	getBackgroundColor(item: YeuCauDuyetGiaChiTiet) {
		if (item.GiaMoi < item.GiaRecommend) {
			return '_dahuy';
		}
		if (item.GiaRecommend == 0) {
			return '_tinhlaigia';
		}
		if (item.GiaMoi > item.GiaRecommend) {
			return '_hoantat';
		}
	}

	getStatus(item: YeuCauDuyetGiaChiTiet) {
		if (item.GiaMoi < item.GiaRecommend) {
			return 'Duyệt lại giá';
		}
		if (item.GiaRecommend == 0) {
			return 'Tính lại giá';
		}
		if (item.GiaMoi > item.GiaRecommend) {
			return 'Không cần duyệt giá';
		}
	}

	//#region Goi api thêm moi, chinh sua
	setYeuCauDuyetGia(status: number = 0) {
		if (this.invalidForm(this.MainForm) == false) return;
		if (this.confirm)
			if (this.invalidForm(this.ConfirmForm) == false) return;

		let data = this.createItem();
		if (this.guilai) {
			data.IdDG = 0;
			data.IdDGGL = this.data.data.IdDGCT;
			data.YeuCauDuyetGiaDetailCT[0].IdDVT = this.data.data.IdDVT
			// if (this.GiaCu == data.YeuCauDuyetGiaDetailCT[0].GiaMoi) {
			// 	this.layoutUtilsService.showErorr("Giá gửi lại phải khác giá cũ");
			// 	return;
			// }
		}
		if (+data.YeuCauDuyetGiaDetailCT[0].GiaMoi == 0) {
			this.layoutUtilsService.showErorr("Vui lòng nhập giá đề nghị bán");
			return;
		}

		if (data) {
			if (status == 1 || status == 2) {
				data.TrangThai_Code = this.TinhTrang[1].value;
				const _sophieu: string = data.SoPhieu;
				const dialogRef = this.layoutUtilsService.POP02(_sophieu);

				dialogRef.afterClosed().subscribe(res => {
					if (!res) {
						return;
					}
					if (data.IdDG > 0) {
						this.YeuCauDuyetGiaService.edit(data).subscribe(res => this.runAfterAddOrUpdate(res, status))
					} else {
						this.YeuCauDuyetGiaService.insert(data).subscribe(res => this.runAfterAddOrUpdate(res, status))
					}
				});
			}
			else {
				data.TrangThai_Code = this.TinhTrang[0].value;
				if (data.IdDG > 0) {
					this.YeuCauDuyetGiaService.edit(data).subscribe(res => this.runAfterAddOrUpdate(res, status))
				} else {
					this.YeuCauDuyetGiaService.insert(data).subscribe(res => this.runAfterAddOrUpdate(res, status))
				}
			}
		}
	}
	//#endregion 

	//#region Data form
	createItem() {
		let controls = this.MainForm.controls;
		let tiente = this.payments.find(x => x.Id == Number(controls['LOAITIEN'].value));
		let hh = this.list_HH.find(x => x.Id_CT == controls['YCBGCT'].value);
		let item = {
			IdDG: this.YeuCauDuyetGiaItem.IdDG,
			IdDGGL: 0,
			SoPhieu: controls['SOPHIEU'].value,
			TrangThai_Code: controls['TRANGTHAI'].value,
			NgayYeuCauBaoGia: moment(controls['NGAYYEUCAUBAOGIA'].value).format('YYYY-MM-DD[T]HH:mm:ss.SSS'),
			YeuCauDuyetGiaDetailCT: [
				{
					YCBGCT: controls['YCBGCT'].value,
					IdHH: controls['IdHH'].value,
					MaHH: controls['MaHH'].value,
					IdDVT: hh.DVT1,
					SoLuong: this.formatComparenumber(controls['SOLUONG'].value.toString()),
					NgayYeuCauGH: moment(controls['NGAYYEUCAUGIAOHANG'].value).format('YYYY-MM-DD[T]HH:mm:ss.SSS'),
					ThoiHanGiuGia: Number(controls['THOIHANGIUGIA'].value.toString()),
					TienTe_Id: Number(controls['LOAITIEN'].value.toString()),
					TienTe_Ten: tiente.Ten,
					TyGia: this.formatComparenumber(controls['TYGIA'].value.toString()),
					GiaMoi: this.formatComparenumber(controls['GIAMOI'].value.toString()),
					GiaGanNhat: this.formatComparenumber(controls['GIAGANNHAT'].value.toString()),
					ThanhTien: this.formatComparenumber(controls['THANHTIEN'].value.toString()),
					ThanhTienQuyDoi: this.formatComparenumber(controls['THANHTIENQUYDOI'].value.toString()),
				}
			]
		}
		return item;
	}
	//#endregion 

	//#region Goi sau khi service tra ve du lieu
	runAfterAddOrUpdate(res, withBack) {
		if (res && res.status == 1) {
			this.isChange = true;
			const message = `Yêu cầu duyệt giá đã được cập nhật thành công.`;
			this.layoutUtilsService.showInfo(message);

			//Cập nhật lại khi đã thêm
			this.saveAddedTTHV = [];
			this.saveAddedTTHV.push(res.data.Id);

			// Luu nháp
			// if (withBack == 0) {
			// 	this.add = false;
			// 	this.edit = true;
			// 	this.YeuCauDuyetGiaItem = res.data;
			// 	this.changeDetectView();
			// 	return;
			// }

			// this.checkGuiDuyet(false);
			// // Lưu và thêm mới
			// if (withBack == 2) {
			// 	this.add = true;
			// 	this.edit = false;
			// 	this.resetForm();
			// 	this.changeDetectView();
			// 	return;
			// }

			// // Lưu và trờ lại
			// if (withBack == 1) {
			// 	this.MainForm.reset();
			// 	this.tmpChiTietYeuCauDuyetGia = [];
			// 	this.tmpChiTietYeuCauDuyetGia = [...this.tmpChiTietYeuCauDuyetGia];
			// 	this.back();
			// }

			this.isChange = true;
			this.back();
		}
		else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}
	//#endregion

	//#region Check Invalid form
	invalidForm(formGroup) {
		const controls = formGroup.controls;
		if (formGroup.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {
					if (invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT') {
						const elementControl = formGroup.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if (elementControl) {
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return false;
		}
	}
	//#endregion

	//#region Reset Form
	resetForm() {
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		this.YeuCauDuyetGiaItem = new YeuCauDuyetGia();
		this.YeuCauDuyetGiaItem.IdDG = 0;
		this.tmpChiTietYeuCauDuyetGia = [];
		this.createBillNumber().then(r => { this.MainForm.controls['SOPHIEU'].setValue(r); });
		this.MainForm.controls['NGAYLAPPHIEU'].setValue(new Date());
		this.MainForm.controls['NGAYYEUCAUBAOGIA'].setValue(new Date());
		this.MainForm.controls['NGUOILAPPHIEU'].setValue(tenNguoiLap);
		this.MainForm.controls['TRANGTHAI'].setValue(this.TinhTrang[0].name);
		this.MainForm.controls['GIAMOI'].setValue(this.f_currency_VND(this.formatNumber('0'.toString())));
		this.MainForm.controls['THOIHANGIUGIA'].setValue('1');
		this.MainForm.controls['NGAYYEUCAUGIAOHANG'].setValue(new Date());
		this.MainForm.controls['KETLUAN'].setValue('0');
		this.MainForm.controls['LOAITIEN'].setValue(this.payments[0].Id.toString());
		this.MainForm.controls['TYGIA'].setValue(this.f_currency_VND(this.formatNumber('1'.toString())));
		this.MainForm.controls['THANHTIEN'].setValue(this.f_currency_VND(this.formatNumber('0'.toString())));
		this.MainForm.controls['THANHTIENQUYDOI'].setValue(this.f_currency_VND(this.formatNumber('0'.toString())));
	}
	//#endregion

	//#region TP, GD Duyet, Khong Duyet
	// code 'truongphong', 'giamdoc'
	setConfirmForm(status: boolean) {
		let formGroup, code;
		formGroup = this.ConfirmForm;
		let controls = formGroup.controls;
		if (status === false) {
			formGroup.controls['LYDO'].setValidators([Validators.compose([Validators.required])]);
			formGroup.controls['LYDO'].updateValueAndValidity();
			if (formGroup.invalid) {
				Object.keys(controls).forEach(controlName =>
					controls[controlName].markAsTouched()
				);
				setTimeout(() => this.focusLyDo.first.nativeElement.focus(), 0);
				return;
			}
		}
		const _sophieu = this.YeuCauDuyetGiaItem.SoPhieu;
		this.YeuCauDuyetGiaItem.LyDo = controls['LYDO'].value;
		if (status) {
			formGroup.controls['LYDO'].clearValidators();
			formGroup.controls['LYDO'].updateValueAndValidity();
			const dialogRef = this.layoutUtilsService.POP03(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				this.YeuCauDuyetGiaItem.TrangThai_Code = this.TinhTrang[3].value;
				this.YeuCauDuyetGiaService.confirm(this.YeuCauDuyetGiaItem).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		} else {
			const dialogRef = this.layoutUtilsService.POP02(_sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				this.YeuCauDuyetGiaItem.TrangThai_Code = this.TinhTrang[2].value;
				this.YeuCauDuyetGiaService.confirm(this.YeuCauDuyetGiaItem).subscribe(res => {
					this.showAfterConfirm(_sophieu, res);
				});
			});

		}
	}
	//#endregion
	//#region Goi sau khi duyet khong duyet
	showAfterConfirm(_sophieu, res) {
		if (res && res.status === 1) {
			const message = 'Phiếu yêu cầu duyệt giá ' + _sophieu + ' cập nhật thành công.';
			this.layoutUtilsService.showInfo(message);
			this.MainForm.reset();
			this.isChange = true;
			this.saveAddedTTHV.push(res.data);
			this.back();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}
	//#endregion

	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}

	changeInputNumberVND(event, columnName, min: number = 0) {

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.formatComparenumber(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				this.MainForm.controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

			} else {
				this.MainForm.controls[columnName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			}

			if (columnName == 'GIAMOI') {
				// // Thay đổi kết luận
				// let recommand = this.formatComparenumber(this.MainForm.controls['RECOMMAND'].value.toString());
				// let giamoi = this.formatComparenumber(data.toString());
				// this.MainForm.controls['KETLUAN'].setValue(this.changeKetLuan(recommand,giamoi).toString());

				// Thay đổi thành tiền
				let thanhtien = this.formatComparenumber(this.MainForm.controls['SOLUONG'].value.toString()) * this.formatComparenumber(this.MainForm.controls['GIAMOI'].value.toString());;
				let tygia = this.formatComparenumber(this.MainForm.controls['TYGIA'].value.toString());
				this.MainForm.controls['THANHTIEN'].setValue(this.f_currency_VND(this.formatNumber((thanhtien).toString())));
				this.MainForm.controls['THANHTIENQUYDOI'].setValue(this.f_currency_VND(this.formatNumber((thanhtien * tygia).toString())));
			}
			if (columnName == 'TYGIA') {
				let thanhtien = this.formatComparenumber(this.MainForm.controls['THANHTIEN'].value.toString())
				let tygia = this.formatComparenumber(data.toString());
				this.MainForm.controls['THANHTIENQUYDOI'].setValue(this.f_currency_VND(this.formatNumber((thanhtien * tygia).toString())));
			}
			this.changeDetect.detectChanges();
		}
	}

	changeInputNumber(event, columnName, min: number = 0) {
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = Number(event.target.value);
			if (data) {
				if (data < min) data = min;
				this.MainForm.controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				this.changeDetectView();
			}
		}
	}

	changeInputNuberOutInput(controlName: string, event: any, min: number = 0) {
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = Number(this.MainForm.controls[controlName].value);
			if (tmpValue < min) tmpValue = min;
			if (!this.MainForm.controls[controlName].invalid) {
				this.MainForm.controls[controlName].setValue(
					tmpValue
				);
				return;
			}
			this.MainForm.controls[controlName].setValue(
				min
			);
		}
		else {
			this.MainForm.controls[controlName].setValue(min);
		}
	}

	changeInputOfFormVND(controlName: string, event: any, min: number = 0) {

		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = this.MainForm.controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!this.MainForm.controls[controlName].invalid) {
				this.MainForm.controls[controlName].setValue(
					this.f_currency_VND(this.formatNumber(tmpValue))
				);
			}
			if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
				tmpValue = min;
			}
			this.MainForm.controls[controlName].setValue(
				this.f_currency_VND(this.formatNumber(tmpValue))
			);

			if (controlName == 'GIAMOI') {
				// Thay đổi kết luận
				// let recommand = this.formatComparenumber(this.MainForm.controls['RECOMMAND'].value.toString());
				// let giamoi = this.formatComparenumber(tmpValue.toString());
				// this.MainForm.controls['KETLUAN'].setValue(this.changeKetLuan(recommand,giamoi).toString());

				// Thay đổi thành tiền
				let thanhtien = this.formatComparenumber(this.MainForm.controls['SOLUONG'].value.toString()) * this.formatComparenumber(this.MainForm.controls['GIAMOI'].value.toString());;
				let tygia = this.formatComparenumber(this.MainForm.controls['TYGIA'].value.toString());
				this.MainForm.controls['THANHTIEN'].setValue(this.f_currency_VND(this.formatNumber((thanhtien).toString())));
				this.MainForm.controls['THANHTIENQUYDOI'].setValue(this.f_currency_VND(this.formatNumber((thanhtien * tygia).toString())));
			}
			if (controlName == 'TYGIA') {
				let thanhtien = this.formatComparenumber(this.MainForm.controls['THANHTIEN'].value.toString())
				let tygia = tmpValue;
				this.MainForm.controls['THANHTIENQUYDOI'].setValue(this.f_currency_VND(this.formatNumber((thanhtien * tygia).toString())));
			}
			this.changeDetect.detectChanges();
		}
		else {
			this.MainForm.controls[controlName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
		}
	}

	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {

		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);

		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu ,';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}

	changeKetLuan(recommand: number, giamoi: number) {
		if (giamoi < recommand) return 0;
		if (recommand == 0) return 1;
		if (giamoi >= recommand) return 2;
	}

	checkDateNull(event) {
		if (!event.target.value) {
			this.MainForm.controls['NGAYYEUCAUGIAOHANG'].setValue(new Date());
			this.changeDetectView();
		}
	}
	clearSelectHH(event: any) {
		this.selectId_HH = '';
		let zero = 0;
		let one = 1;
		let controls = this.MainForm.controls;
		controls["MAHH"].setValue('');
		controls["TENHH"].setValue('');
		controls["QUYCACH"].setValue('');
		controls["DVT"].setValue('');
		controls['SOLUONG'].setValue(this.f_currency_VND(this.formatNumber(zero.toString())));
		//controls['RECOMMAND'].setValue(this.f_currency_VND(this.formatNumber(zero.toString())));
		controls['GIAMOI'].setValue(this.f_currency_VND(this.formatNumber(zero.toString())));
		controls['THOIHANGIUGIA'].setValue(one);
		controls['NGAYYEUCAUGIAOHANG'].setValue(new Date());
		controls['KETLUAN'].setValue(zero.toString());
		controls['LOAITIEN'].setValue(this.payments[0].Id.toString());
		controls['TYGIA'].setValue(this.f_currency_VND(this.formatNumber(one.toString())));
		controls['THANHTIEN'].setValue(this.f_currency_VND(this.formatNumber(zero.toString())));
		controls['THANHTIENQUYDOI'].setValue(this.f_currency_VND(this.formatNumber(zero.toString())));
		event.stopPropagation();

	}

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}

	// getKHTheoPhieuBG(){

	// 	if(this.list_YCBG.length>0){
	// 		var controls = this.MainForm.controls;
	// 		var itemPhieuBG=this.list_YCBG.filter(x=>x.Id==controls['SOPHIEUYCBG'].value);
	// 		 controls['MaKH'].setValue(itemPhieuBG[0].Makh);
	// 		 controls['TenKH'].setValue(itemPhieuBG[0].Tenkh)
	// 		this.changeDetectView();
	// 	}


	// }

	changeThanhTien() {
		var controls = this.MainForm.controls;
		var giaMoi = this.FormatCommaNumber(controls['SOLUONG'].value + '') + this.FormatCommaNumber(controls['GIAMOI'].value + '');
		controls['THANHTIEN'].setValue(this.f_currency_VND(this.formatNumber(giaMoi + '')));
		this.changeDetectView();
	}

	FormatCommaNumber(item: string) {
		return Number(item.replace(/,/g, ""));
	}
	timKiemNangCao() {
		const dialogRef = this.dialog.open(TimKiemNangCaoListComponent, {
			data: {
				kw: ''
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
			else {
				if (!res.isChange) {
					return;
				}
				if (res.dataAdd.length != 0) {
					let controls = this.MainForm.controls;
					controls['YCBGCT'].setValue(res.dataAdd[0] + '');
					this.changeDetect.detectChanges()
				}
			}
		});
	}
}

